import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useMenuStore } from '../zustand/store/useMenuStore';
import useQueryLinkNavigate from '../hooks/useQueryLinkNavigate';
import useConfirm from '../hooks/useConfirm';
import { useModalOpen } from '../hooks/useToastModalOpen';

import { useDynamicStyle } from '../hooks/useDynamicStyle';
import * as Theme from '../images/icons/icons_theme';
import { useRef } from 'react';

const Navi = ({isSidebarToggle, favMenuOpen, setFavMenuOpen, homeRef, favMenuRef, favBtnRef, nextRef, handleSmallMoniterMenuClick}) => {

    const navigation = useNavigate();
    const { pathname, isHome } = useQueryLinkNavigate();
    
    // Dynamic Style Hook
    const { fontColor, primaryBackColor } = useDynamicStyle();

    const clickedCategory = useMenuStore((state) => state.clickedCategory);

    // confirm hook
    const confirm = useConfirm();

    // toast modal open function
    const { toastModalOpen } = useModalOpen();

    const resetMenus = useMenuStore(state => state.resetMenus);

    const logout = async () => {
        const ok = await confirm('로그아웃 하시겠습니까?');
        if(!ok) return false;

        // 서버 쪽도 정리한다(세션 무효화 · 로그인 토큰 삭제 · 토큰 쿠키 삭제).
        // 브라우저 저장소만 지우면 서버 세션이 살아 있어 로그아웃이 아니다.
        // 이미 만료됐거나 실패해도 화면 정리는 계속한다.
        try {
            await axios.post('/commonapi/logout.do');
        } catch (e) {
            // 무시
        }
        delete axios.defaults.headers.common['Authorization'];

        Object.keys(localStorage).forEach((key) => {
            if (!key.startsWith('pophide_')) {
                localStorage.removeItem(key);
            }
        });
        
        navigation('/member/login.do', { state: {pathname, isLogout : true} });
        resetMenus();
        toastModalOpen('로그아웃 되었습니다.');
    };

    const handleAnchorFocus = (e) => {
        if(!isHome) {
            if (favMenuOpen && favMenuRef && favMenuRef.current) {
                const firstDeleteBtn = favMenuRef.current.querySelector('.fav_menu_list');
                if (firstDeleteBtn) {
                    firstDeleteBtn.focus();
                }
            } else {
                if (e.key === 'Tab' && !e.shiftKey) {
                    e.preventDefault();
                    if (nextRef && nextRef.current) {
                        nextRef.current.focus();
                    }
                }
            }
        }
    };
    
    const favListRef = useRef(null);

    // 카테고리별 아이콘 색상 클래스 접두어 (관리·홈은 ho 공용)
    const theme = clickedCategory === 3 ? 'st' : clickedCategory === 21 ? 'tr' : 'ho';

    const handleFav = (e) => {
        if(!favMenuOpen) {
            e.preventDefault();
            setFavMenuOpen(true);

            setTimeout(() => {
            if (favListRef.current) {
                favListRef.current.focus();
            }
        }, 100);
        }
    }

    const navItems = [
        {
            title: 'Home',
            icon: <Theme.NavHome className={`${theme}_primary`} />,
            hoverIcon: <Theme.NavHome className={`${theme}_bright`} />,
            ref: homeRef,
            onFocus: () => setFavMenuOpen(false),
            onClick: () => {navigation('/'); handleSmallMoniterMenuClick();}
        },
        {
            title: '즐겨찾기',
            icon: <Theme.StarFull className={`${theme}_primary`} />,
            hoverIcon: <Theme.StarFull className={`${theme}_bright`} />,
            ref: favBtnRef,
            onClick: (e) => handleFav(e)
        },
        {
            title: '즐겨찾기 리스트',
            ref: favListRef,
            onFocus: (e) => handleAnchorFocus(e),
            hidden: true
        },
        {
            title: '로그아웃',
            icon: <Theme.NavLogout className={`${theme}_primary`} />,
            hoverIcon: <Theme.NavLogout className={`${theme}_bright`} />,
            ref: nextRef,
            onFocus: () => setFavMenuOpen(false),
            onClick: logout
        }
    ];

    return (
        <>
        {isHome ?
            <button ref={nextRef} className='home_nav_wrapper h_icon_box' onClick={logout}>
                <div className='icon'><Theme.NavLogout className='ho_primary' /></div>
                <div className='hover_icon'><Theme.NavLogout className='ho_dark' /></div>
                <div className='home_nav_text'>로그아웃</div>
            </button>
        :
            <div className={`nav_wrapper ${isSidebarToggle ? 'flex-row' : 'flex-col'}`}>
                {navItems.map(({ title, icon, hoverIcon, ref, hidden, onClick, onFocus }, index) => {
                    const clickedFav = (favMenuOpen && title === '즐겨찾기')
                    return (
                        <button key={index} ref={ref} onClick={onClick} onFocus={onFocus} className={`tooltip_box relative ${hidden ? 'fav_dummy_box ' + (!favMenuOpen && 'hidden') : ''}`} aria-hidden={hidden}>
                            <div className={`nav_box h_icon_box ${fontColor}`}>
                                <div className='icon'>{clickedFav ? hoverIcon : icon}</div>
                                <div className='hover_icon'>{hoverIcon}</div>
                            </div>
                            <span className={`tooltip ${isSidebarToggle ? 'open_nav_tool_position' : 'close_nav_tool_position'} ${primaryBackColor}`}>
                                {title}
                            </span>
                        </button>
                    )
                })}
            </div>
        }
        </>
    )
}

export default Navi